import { media, styled } from '@nx-kit/styling';
import Container from 'components/layout/Grid/Container';
import { Heading } from 'components/atoms/Heading';
import Column from 'components/layout/Grid/Column';
import Link from 'components/atoms/Link/Link';

export const Wrapper = styled(Container)`
  overflow: hidden;
  margin-bottom: -30px;
  padding-bottom: 30px;
`;

export const HeadlineCol = styled(Column)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HeadingStyled = styled(Heading)`
  margin: -8px 0 12px;
  font-size: 18px;
  line-height: 1.25;

  ${media('md')} {
    margin: -4px 0 20px;
    font-size: 28px;
  }
`;
export const SliderWrapper = styled.div`
  margin-top: 40px;

  ${media('md')} {
    margin-top: 30px;
  }
`;

export const ColumnLinkStyled = styled(Column)`
  margin-top: 15px;
`;

export const StyledMobileLink = styled(Link)`
  font-size: ${({ theme }) => theme.global.fontSize.medium}px;
`;
